// Per-row "..." actions menu, shared by Properties and Entities.
import { useState } from 'react';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';

export type RowAction = {
  key: string;
  label: string;
  icon: React.ComponentType<{ fontSize?: 'small' | 'inherit' | 'default' | 'large' }>;
  onClick: () => void;
};

export const RowActionsMenu = ({ actions }: { actions: RowAction[] }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  if (actions.length === 0) return <span />;

  return (
    <>
      <IconButton
        size="small"
        aria-label="actions"
        onClick={(event) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {actions.map((action) => (
          <MenuItem
            key={action.key}
            onClick={(event) => {
              event.stopPropagation();
              setAnchorEl(null);
              action.onClick();
            }}
          >
            <ListItemIcon style={{ minWidth: 32 }}>
              <action.icon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{action.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
